import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const AiIcon = ({ classObject }) => {
    return React.createElement("img", { className: css(styles.container, classObject), src: "/assets/images/icons/ai_idea.svg" });
};
const styles = StyleSheet.create({
    container: {},
});
